import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import Box from '@mui/material/Box';
import DialogContent from '@mui/material/DialogContent';
import Paper from '@mui/material/Paper';
import Avatar from '@mui/material/Avatar';
import Typography from '@mui/material/Typography';
import DialogActions from '@mui/material/DialogActions';
import Button from '@mui/material/Button';
import * as React from 'react';
import { AvailablePhotographer } from "../../types";

export type PhotographerSelectionDialogLabels = {
    photographerSelectionDialogTitle: string;
    closePhotographerSelection: string;
};

type PhotographerSelectionDialogProps = {
    availablePhotographers: AvailablePhotographer[];
    isOpen: boolean;
    onChange: (photographerId: number) => void;
    onClose: () => void;
    labels: PhotographerSelectionDialogLabels;
};

export function PhotographerSelectionDialog({
    availablePhotographers,
    isOpen,
    labels,
    onChange,
    onClose
}: PhotographerSelectionDialogProps) {
    let { apiUrl } = window.appConfig;

    return (
        <Dialog onClose={onClose} open={isOpen} fullWidth={true}>
            <DialogTitle>{labels.photographerSelectionDialogTitle}</DialogTitle>
            <Box
                component="hr"
                sx={{
                    color: 'text.secondary',
                    margin: 'unset'
                }}
            />
            <DialogContent
                sx={{
                    padding: '20px',
                    width: '100%',
                    height: '100%',
                    backgroundColor: 'rgba(250, 250, 250, 1)',
                    display: 'flex',
                    flexDirection: 'column',
                    gap: '16px'
                }}
            >
                {availablePhotographers.map((photographer) => (
                    <Paper
                        key={photographer.id}
                        sx={{
                            display: 'flex',
                            gap: '8px',
                            padding: '8px',
                            cursor: 'pointer',
                            alignItems: 'center'
                        }}
                        onClick={() => {
                            onChange(photographer.id);
                        }}
                    >
                        <Avatar
                            alt={`Profile image of photographer ${photographer.name}`}
                            src={`${apiUrl}/file/${photographer.profileImageReference}`}
                        />
                        <Typography
                            variant="body1"
                            sx={{
                                fontSize: '16px',
                                fontFamily: 'Gilroy',
                                color: 'text.primary'
                            }}
                        >
                            {photographer.name}
                        </Typography>
                    </Paper>
                ))}
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose}>{labels.closePhotographerSelection}</Button>
            </DialogActions>
        </Dialog>
    );
}
